import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/button/Button";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="text-center">
        <h1 className="text-7xl font-bold text-gray-800">404</h1>
        <p className="mt-4 text-2xl font-semibold text-gray-600">
          Oops! Page Not Found.
        </p>
        <p className="mt-2 text-lg text-gray-500">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <div className="max-w-sm mx-auto">
          <Button
            onClick={handleGoHome}
            className="mt-6"
          >
            Go Back Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
